export const vitalsValidationSchema = {
  heartRate: {
    min: 30,
    max: 250,
    typeError: 'Must be a number',
    minError: 'Heart rate too low',
    maxError: 'Heart rate too high',
  },
  respiratoryRate: {
    min: 8,
    max: 60,
    typeError: 'Must be a number',
    minError: 'Respiratory rate too low',
    maxError: 'Respiratory rate too high',
  },
  systolicBp: {
    min: 70,
    max: 250,
    typeError: 'Must be a number',
    minError: 'Systolic BP too low',
    maxError: 'Systolic BP too high',
  },
  diastolicBp: {
    min: 40,
    max: 150,
    typeError: 'Must be a number',
    minError: 'Diastolic BP too low',
    maxError: 'Diastolic BP too high',
  },
  spo2: {
    min: 70,
    max: 100,
    typeError: 'Must be a number',
    minError: 'SpO2 too low',
    maxError: 'SpO2 too high',
  },
  temperature: {
    min: 30,
    max: 45,
    typeError: 'Must be a number',
    minError: 'Temperature too low',
    maxError: 'Temperature too high',
  },
  bloodGlucose: {
    min: 20,
    max: 1000,
    typeError: 'Must be a number',
    minError: 'Blood glucose too low',
    maxError: 'Blood glucose too high',
  },
  height: {
    min: 30,
    max: 300,
    typeError: 'Must be a number',
    minError: 'Height too low',
    maxError: 'Height too high',
  },
  weight: {
    min: 1,
    max: 500,
    typeError: 'Must be a number',
    minError: 'Weight too low',
    maxError: 'Weight too high',
  },
  bmi: {
    min: 10,
    max: 70,
    typeError: 'Must be a number',
    minError: 'BMI too low',
    maxError: 'BMI too high',
  },
  posture: {
    options: ['Sitting', 'Standing', 'Lying', 'Other'] as const,
    invalidError: 'Invalid posture',
    requiredError: 'Posture is required',
  },
} as const

export const campTabs = {
  active: 'Active',
  upComing: 'UpComping',
  completed: 'Closed',
}

export const salutationOptions = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Master', label: 'Master' },
  { value: 'Baby', label: 'Baby' },
  { value: 'Baby of', label: 'Baby of' },
]

export const preferredCommunicationOptions = [
  { value: 'Whatsapp', label: 'Whatsapp' },
  { value: 'Sms', label: 'Sms' },
]

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
]
export const activeText = 'active'

export const COMPLAINTS = [
  'Fever',
  'Cold',
  'Cough',
  'Sore throat',
  'Headache',
  'Stomach pain',
  'Vomiting',
  'Diarrhea',
  'Chest pain',
  'Breathlessness',
  'Fatigue/Weakness',
  'Body pains',
]

export const hours = '24Hours'
export const days = '48Hours'
export const moreThanDays = '72Hours'
export const textHours = 'hours'
export const textFunction = 'function'
export const textErrorMessage =
  'Visit ID is required for uploading files. Please ensure the patient has an active visit.'
export const textSuccess = 'File uploaded successfully'
export const textFailed = 'Failed to upload file'
export const textMissing = 'Missing required camp or patient information'
export const textNoVisit = 'No valid visit ID found for this patient'
export const textHeightRequire = 'Height is required'
export const textWeightRequire = 'Weight is required'

export const medicalHistoryTexts = {
  updateSuccess: 'Medical history updated successfully',
  saveSuccess: 'Medical history saved successfully',
  saveError: 'Failed to save medical history',
  defaultCondition: 'nothing',
  defaultAdditionalNotes: 'nothing',
  defaultDrugAllergy: 'nothing',
} as const

export const DURATION_OPTIONS = [
  { value: 1, label: '24 hours' },
  { value: 2, label: '48 hours' },
  { value: 3, label: '72 hours or more' },
]

// Visit Dashboard Constants
export const visitDashboardConstants = {
  // Intent names
  intents: {
    allAppointments: 'allAppointments',
    getEncounterForAppointments: 'getEncounterForAppointments',
    closeEncounter: 'closeEncounterForAppointment',
    getAllSubEncounters: 'getAllSubEncounters',
    getPatientVisits: 'getPatientVisits',
    getPatientApi: 'getPatientApi',
    getallVisitmedication: 'getallVisitmedication',
    getLabOrdersByPatientIds: 'getLabOrdersByPatientIds',
    getTreatmentPlan: 'getTreatmentPlan',
  },

  official: 'official',

  // Resource types
  resourceTypes: {
    encounter: 'Encounter',
    practitioner: 'Practitioner',
  },
  // Default values
  defaults: {
    patientIdentifier: 'patient-identifier',
    notSpecified: 'Not specified',
    mobile: 'mobile',
    string: 'string',
    object: 'object',
    yes: 'yes',
    number: 'number',
    function: 'function',
    defaultNumber: '0',
    defaultString: '',
  },
  // Component codes for treatment plan
  treatmentPlanCodes: {
    treatmentPlan: 'treatmentPlan',
    followUpAdvice: 'followUpAdvice',
    homeAdvice: 'homeAdvice',
    referralRequired: 'referralRequired',
    referralDoctor: 'referralDoctor',
    referralDepartment: 'referralDepartment',
    referralReason: 'referralReason',
  },
  // Visit statuses
  visitStatus: {
    finished: 'finished',
  },
  // File types and constants
  files: {
    audioMimeType: 'audio/webm',
    defaultMimeType: 'application/octet-stream',
  },
  // Element IDs
  elementIds: {
    campInlineContainer: 'camp-inline-container',
  },
  // Timeouts
  timeouts: {
    mountDelay: 50,
    scrollDelay: 100,
  },
}
export const SPONSORED_BY_NULL = 'Sponsored by : null'

export const columnValue = {
  // Add your column values here
} as const

export const TEST_TYPES = {
  PFT: 'pft',
  ECG: 'ecg',
  PAP: 'pap',
} as const

export const NORMAL = 'normal'

export type TestType = (typeof TEST_TYPES)[keyof typeof TEST_TYPES]

export const vitalsMessages = {
  success: {
    saved: 'Vitals saved successfully',
    updated: 'Vitals updated successfully',
  },
  errors: {
    saveFailed: 'Failed to save vitals',
    updateFailed: 'Failed to update vitals',
    fetchFailed: 'Failed to fetch vitals',
    generic: 'An error occurred while processing your request',
    saveError: 'An error occurred while saving vitals',
  },
  defaults: {
    visitType: 'opd/general',
    number: '0',
    emptyString: '',
    defaultPosture: 'Sitting',
    defaultTemperatureUnit: 'C',
    defaultBloodGlucoseType: 'random',
    bloodGlucoseTypes: {
      random: 'random',
      fasting: 'fasting',
      postprandial: 'postprandial',
    },
  },
  intents: {
    view: 'view',
    edit: 'edit',
    create: 'create',
  },
  fieldTypes: {
    select: 'select',
    number: 'number',
    text: 'text',
  },
  labels: {
    heartRate: 'Heart Rate',
    respiratoryRate: 'Respiratory Rate',
    systolicBp: 'Systolic BP',
    diastolicBp: 'Diastolic BP',
    spo2: 'SpO2',
    temperature: 'Temperature',
    bloodGlucose: 'Blood Glucose',
    height: 'Height',
    weight: 'Weight',
    bmi: 'BMI',
    posture: 'Posture',
    temperatureUnit: 'Temperature Unit',
    bloodGlucoseType: 'Blood Glucose Type',
  },
} as const

export const errorMessages = {
  camp: {
    nameRequired: 'Camp name is required',
    locationRequired: 'Location is required',
    locationSelect: 'Please select a location',
    startDateRequired: 'Start date is required',
    endDateRequired: 'End date is required',
    dateRangeInvalid: 'Start date cannot be after end date',
    campTypeRequired: 'Please select a camp type',
    maleLabPackageRequired: 'Male lab package is required',
    femaleLabPackageRequired: 'Female lab package is required',
    success: {
      updated: 'Camp updated',
      updateFailed: 'Update failed',
    },
    doctorMappings: {
      atLeastOneRequired: 'At least one doctor mapping is required',
      oneActiveRequired: 'At least one doctor must be active',
      specializationRequired: 'Specialization is required',
      doctorRequired: 'Doctor is required',
      appointmentTypeRequired: 'Select at least one appointment type',
    },
    patient: {
      firstNameRequired: 'First Name is required',
      lastNameRequired: 'Last Name is required',
      genderRequired: 'Gender is required',
      dobRequired: 'Date of Birth is required',
      phoneNumber: {
        required: 'Phone Number is required',
        invalid: 'Phone number must be 10 digits',
      },
      preferredCommunicationRequired: 'Preferred Communication is required',
      emailInvalid: 'Invalid email address',
      postalCode: {
        required: 'Postal Code is required',
        invalid: 'Postal code must be 6 digits',
      },
      registration: {
        update: 'Patient Updated successfully',
        success: 'Patient registered successfully',
        error: 'Error registering patient',
        genericError: 'An error occurred while registering the patient',
      },
      selectOption: 'Select an option',
      fileUpload: {
        success: 'Files uploaded successfully!',
        error: 'Failed to upload files',
      },
    },
    fileUpload: {
      success: 'Files uploaded successfully!',
      error: 'Failed to upload files',
      selectAtLeastOneTestType:
        'Please select at least one test type and upload files',
      failedToSaveFiles: 'Failed to save files',
      documentDeletedSuccessfully: 'Document deleted successfully',
      failedToDeleteDocument: 'Failed to delete document',
    },
    patientUhidAndVisitIdRequired:
      'Patient UHID and Visit ID are both required',
    visitIdRequired:
      'Visit ID is required for uploading files. Please ensure the patient has an active visit.',
    patientUhidRequired: 'Patient UHID is required',
    testTypeLabels: {
      [TEST_TYPES.PFT]: 'PFT (Pulmonary Function Test)',
      [TEST_TYPES.ECG]: 'ECG (Electrocardiogram)',
      [TEST_TYPES.PAP]: 'PAP (Pulmonary Artery Pressure)',
    },
    testTypeShortLabels: {
      [TEST_TYPES.PFT]: 'PFT',
      [TEST_TYPES.ECG]: 'ECG',
      [TEST_TYPES.PAP]: 'PAP',
    },
    fileUploadUI: {
      uploadDocuments: 'Upload Documents',
      testTypes: 'Test Types',
      dragAndDropText: 'Drag & drop files here or',
      clickToBrowse: 'click to browse',
      uploadedFiles: 'Uploaded Files',
      untitledDocument: 'Untitled Document',
      previewTooltip: 'Preview',
      downloadTooltip: 'Download',
      deleteTooltip: 'Delete',
      saveButton: 'Save',
      saveButtonSaving: 'Saving...',
      closeButton: 'Close',
      imagePreview: 'Image Preview',
      fileTypes: 'image/*,.pdf,.doc,.docx,.xls,.xlsx',
    },
  },
} as const

// Type Definitions
export type BloodGlucoseType = 'random' | 'fasting' | 'postprandial'
export type TemperatureUnit = 'C' | 'F'
export type Posture = 'Sitting' | 'Supine'

// Default Values
// BMI Status Types
export type BMIStatusValue = 'Underweight' | 'Normal' | 'Overweight' | 'Obese'

export interface BMIStatus {
  status: BMIStatusValue
  color: string
}

// Vitals Field Type
// type VitalsField = {
//   name: string
//   label: string
//   type: 'number' | 'text' | 'select'
//   unit?: string
//   showUnitToggle?: boolean
// }

// Vitals Component Constants
export const vitalsComponent = {
  // Section Titles
  sections: {
    vitals: 'Vitals',
    bloodGlucose: 'Blood Glucose',
    heightWeight: 'Height & Weight',
  },

  // Field Labels
  labels: {
    heartRate: 'Heart Rate',
    respiratoryRate: 'Respiratory Rate',
    systolicBp: 'Systolic BP',
    diastolicBp: 'Diastolic BP',
    spo2: 'SpO₂',
    temperature: 'Temperature',
    bloodGlucose: 'Blood Glucose',
    bloodGlucoseType: 'Type',
    height: 'Height',
    weight: 'Weight',
    bmi: 'BMI',
    posture: 'Posture',
  },

  // Units
  units: {
    bpm: 'bpm',
    breathsPerMin: 'breaths/min',
    mmhg: 'mmHg',
    percent: '%',
    celsius: '°C',
    fahrenheit: '°F',
    mgdL: 'mg/dL',
    cm: 'cm',
    kg: 'kg',
  },

  // Button Texts
  buttons: {
    save: 'Save Vitals',
    saving: 'Saving...',
    update: 'Update Vitals',
    cancel: 'Cancel',
  },

  // Default Values
  defaults: {
    emptyString: '',
    defaultBloodGlucoseType: 'random',
    defaultTemperatureUnit: 'C',
    defaultPosture: 'Sitting',
  },

  // Select Options
  options: {
    postures: [
      { value: 'Sitting', label: 'Sitting' },
      { value: 'Supine', label: 'Supine' },
    ] as const,
  },

  // Error Messages
  errors: {
    saveFailed: 'Failed to save vitals',
    updateFailed: 'Failed to update vitals',
    fetchFailed: 'Failed to fetch vitals',
    invalidValue: 'Invalid value',
  },

  // Form Fields Configuration
  fields: [
    {
      name: 'heartRate',
      label: 'Heart Rate',
      type: 'number',
      unit: 'bpm',
      showUnitToggle: false,
    },
    {
      name: 'respiratoryRate',
      label: 'Respiratory Rate',
      type: 'number',
      unit: 'breaths/min',
      showUnitToggle: false,
    },
    {
      name: 'systolicBp',
      label: 'Systolic BP',
      type: 'number',
      unit: 'mmHg',
      showUnitToggle: false,
    },
    {
      name: 'diastolicBp',
      label: 'Diastolic BP',
      type: 'number',
      unit: 'mmHg',
      showUnitToggle: false,
    },
    {
      name: 'spo2',
      label: 'SpO₂',
      type: 'number',
      unit: '%',
      showUnitToggle: false,
    },
    {
      name: 'temperature',
      label: 'Temperature',
      type: 'number',
      unit: '°F',
      showUnitToggle: true,
    },
  ] as const,
} as const

// Medical History Constants
export const medicalHistoryMessages = {
  success: {
    updated: 'Medical history updated successfully',
    created: 'Medical history created successfully',
  },
  error: {
    fetchFailed: 'Failed to fetch medical history',
    saveFailed: 'Failed to save medical history',
  },
  placeholders: {
    previousSurgeries: 'List any previous surgeries with dates if known...',
    drugAllergies: 'List any known drug allergies and reactions...',
    otherConditions: 'List any other medical conditions not mentioned above...',
    additionalNotes: 'Additional notes...',
  },
  sections: {
    title: 'Past Medical History',
    previousSurgeries: 'Previous Surgeries',
    drugAllergies: 'Drug Allergies',
    otherConditions: 'Other Conditions (Specify)',
    additionalNotes: 'Additional Notes',
  },
  buttons: {
    save: 'Save',
    saving: 'Saving...',
  },
  defaults: {
    emptyField: 'nothing',
  },
}
export const MEDICAL_HISTORY_DEFAULTS = [
  { id: 'hypertension', name: 'Hypertension', selected: false },
  { id: 'diabetes', name: 'Diabetes Mellitus', selected: false },
  {
    id: 'coronary_artery_disease',
    name: 'Coronary Artery Disease',
    selected: false,
  },
  {
    id: 'cerebrovascular_accident',
    name: 'Cerebrovascular Accident',
    selected: false,
  },
  { id: 'bronchial_asthma', name: 'Bronchial Asthma', selected: false },
  {
    id: 'chronic_kidney_disease',
    name: 'Chronic Kidney Disease (CKD)',
    selected: false,
  },
  { id: 'tuberculosis', name: 'Tuberculosis (TB)', selected: false },
  { id: 'epilepsy', name: 'Epilepsy', selected: false },
  { id: 'thyroid_disorder', name: 'Thyroid Disorder', selected: false },
]
export const MEDICAL_HISTORY_ITEMS = [
  'Hypertension',
  'Diabetes Mellitus',
  'Coronary Artery Disease',
  'Cerebrovascular Accident',
  'Bronchial Asthma',
  'Chronic Kidney Disease (CKD)',
  'Tuberculosis (TB)',
  'Epilepsy',
  'Thyroid Disorder',
] as const

export const MEDICAL_HISTORY_PREFIX = 'PastMedicalHistory'
export const TEXT_VISIT_ID = 'Visit ID is required to fetch complaints'

// Default Values
export const VITALS_DEFAULTS = {
  VISIT_TYPE: 'opd/general',
  NUMBER_TYPE: 'number',
}

// BMI Status Configuration
export const BMI_STATUS_CONFIG: Record<
  BMIStatusValue,
  Omit<BMIStatus, 'status'>
> = {
  Underweight: { color: 'warning.main' },
  Normal: { color: 'success.main' },
  Overweight: { color: 'warning.main' },
  Obese: { color: 'error.main' },
}

export const getBMIStatus = (bmi: number): BMIStatus => {
  if (bmi === 0) return { status: 'Normal', color: 'text.primary' }
  if (bmi < 18.5) return { status: 'Underweight', color: 'warning.main' }
  if (bmi < 25) return { status: 'Normal', color: 'success.main' }
  if (bmi < 30) return { status: 'Overweight', color: 'warning.main' }
  return { status: 'Obese', color: 'error.main' }
}

// Chief Complaints Constants
export const chiefComplaintsConstants = {
  placeholders: {
    additionalComments: 'Enter any additional comments here...',
    submitButton: 'Submit',
    submittingButton: 'Submitting...',
  },
}

export const MEDICAL_TESTS = [
  { key: 'oral', label: 'Oral Examinations' },
  { key: 'gynEye', label: 'Gyn/Eye Exams' },
  { key: 'ecg', label: 'ECG' },
  { key: 'pft', label: 'Pulmonary Function Test' },
  { key: 'psa', label: 'PSA Tests' },
  { key: 'papSmear', label: 'Pap Smears' },
  { key: 'iscanBreast', label: 'iScan Breast Exams' },
  { key: 'labInvestigations', label: 'Lab Investigations' },
] as const

export const POSTURE_OPTIONS = [
  { value: 'Sitting', label: 'Sitting' },
  { value: 'Supine', label: 'Supine' },
]

export const TYPES_OF_GLUCOSE = {
  RANDOM: 'rbs',
  FASTING: 'fbs',
  POSTPRANDIAL: 'ppbs',
  BLOOD_GLUCOSE: 'Blood Sugar (mg/dL)',
} as const

export const BLOOD_GLUCOSE_TYPES = {
  RANDOM: 'random',
  FASTING: 'fasting',
  POSTPRANDIAL: 'postprandial',
} as const
